import { searchParamsKeys } from '../../constants'
import { useChangeSearchParams } from '../../../../utils/useChangeSearchParams'

export const useChangeSearchText = (setSearchText: (value: string) => void) => {
  const { onChangeSearchParam, searchParams } = useChangeSearchParams()

  const onChangeSearchText = (searchText: string, _count: number) => (e: { target: { value: string } }) => {
    if (searchText.trim().length && e.target.value.trim() === '') {
      const delayDebounceFn = setTimeout(() => {
        onChangeSearchParam({ key: searchParamsKeys.SEARCH_VALUE, value: '' })
      }, 500)
      setSearchText(e.target.value)
      return () => clearTimeout(delayDebounceFn)
    }
    setSearchText(e.target.value)
  }

  return { onChangeSearchText, searchParams }
}
